import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import AdminLogin from './components/AdminLogin';
import ModuleSelector from './components/ModuleSelector';
import ModuleEditor from './components/ModuleEditor';

export default function AdminPage() {
  const [authed, setAuthed] = useState(false);
  const [selectedModule, setSelectedModule] = useState<string | null>(null);
  const [publishedIds, setPublishedIds] = useState<string[]>([]);

  useEffect(() => {
    const stored = sessionStorage.getItem('nube_admin_auth');
    if (stored === 'true') setAuthed(true);
  }, []);

  useEffect(() => {
    if (!authed) return;
    supabase
      .from('module_content')
      .select('module_id, is_published')
      .then(({ data }) => {
        if (data) {
          setPublishedIds(data.filter((r: { module_id: string; is_published: boolean }) => r.is_published).map((r: { module_id: string }) => r.module_id));
        }
      });
  }, [authed, selectedModule]);

  const handleLogout = () => {
    sessionStorage.removeItem('nube_admin_auth');
    setAuthed(false);
    setSelectedModule(null);
  };

  if (!authed) {
    return <AdminLogin onSuccess={() => setAuthed(true)} />;
  }

  return (
    <div style={{ background: '#0D0F12', minHeight: '100vh' }}>
      {/* Admin navbar */}
      {!selectedModule && (
        <div
          className="px-6 py-4 flex items-center justify-between"
          style={{ borderBottom: '1px solid rgba(248,246,243,0.07)' }}
        >
          <div className="flex items-center gap-3">
            <div
              className="w-8 h-8 flex items-center justify-center rounded-lg"
              style={{ background: 'rgba(139,157,131,0.12)', border: '1px solid rgba(139,157,131,0.20)' }}
            >
              <i className="ri-shield-keyhole-line text-[#8B9D83] text-sm" />
            </div>
            <div>
              <h1 className="text-[#F8F6F3] font-semibold text-sm">Panel de Administración</h1>
              <p className="text-[#F8F6F3]/30 text-[10px]">Nube Geodésica</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 px-4 py-2 rounded-xl text-xs cursor-pointer transition-all duration-200 hover:opacity-70 whitespace-nowrap"
            style={{ background: 'rgba(201,123,99,0.10)', color: '#C97B63', border: '1px solid rgba(201,123,99,0.15)' }}
          >
            <i className="ri-logout-box-r-line" />
            Cerrar sesión
          </button>
        </div>
      )}

      {selectedModule ? (
        <ModuleEditor
          moduleId={selectedModule}
          onBack={() => setSelectedModule(null)}
        />
      ) : (
        <ModuleSelector
          publishedIds={publishedIds}
          onSelect={(id) => setSelectedModule(id)}
        />
      )}
    </div>
  );
}
